import { FC } from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  Image,
  Text,
  Container,
  Spinner,
} from "@chakra-ui/react";
import { useVehicleList } from "./../../hooks";
import { useRedirect } from "./../../hooks/useNavigate";
import { column } from "../../helpers";
import { TableHead } from "../../../home/components/TableHead";
import { FuncButton } from "../../../customComponents/components/FuncButton";

export const TableVehicle: FC = () => {
  const { vehiclesList, deleteVehicle, vehicleLoading } = useVehicleList();
  const { redirectToEdit } = useRedirect();

  if (vehicleLoading) {
    return (
      <Container height="calc(100vh - 240px)">
        <Spinner position={"absolute"} top="50%" right="50%" size="xl" />
      </Container>
    );
  }
  return (
    <TableHead column={column}>
      {vehiclesList.map(({ id, title, video, main_image }) => {
        const srcImg = `${process.env.REACT_APP_API_URL}/${main_image}`;
        const srcVideo = `${process.env.REACT_APP_API_URL}/${video}`;
        return (
          <Tr key={id}>
            <Td>
              <Text fontSize="sm" color="#121419">
                {id}
              </Text>
            </Td>
            <Td>
              <Text fontSize="sm" color="#121419">
                {title}
              </Text>
            </Td>
            <Td>
              {main_image ? (
                <Image src={srcImg} alt="Main photo" maxHeight={"70px"} />
              ) : (
                <Text fontSize="md" color="#121419">
                  Изображение отсутствует
                </Text>
              )}
            </Td>
            {/* <Td>
              {video ? (
                <Image src={srcVideo} alt="Main video" />
              ) : (
                <Text fontSize="md" color="#121419">
                  Изображение отсутствует
                </Text>
              )}
            </Td> */}
            <Td isNumeric>
              <FuncButton onClick={() => redirectToEdit(id)}>
                РЕДАКТИРОВАТЬ
              </FuncButton>
            </Td>
            <Td isNumeric>
              <Button onClick={() => deleteVehicle(id)}>УДАЛИТЬ</Button>
            </Td>
          </Tr>
        );
      })}
    </TableHead>
  );
};
